import React, { useState, useEffect } from 'react';
import { serverNowMs } from '../utils/serverTime';

// Окно оплаты брони. ВАЖНО: значение зеркалит backend CheckAndCancelAbandonedCreatedSessions
// (created-сессия старше 10 минут авто-отменяется, а её платёжная ссылка гасится).
// Показываем клиенту обратный отсчёт, чтобы он не удивлялся отмене и торопился оплатить.
const PAY_WINDOW_MINUTES = 10;

/**
 * PaymentDeadlineTimer — маленький таймер «сколько осталось на оплату брони».
 * @param {string} createdAt - session.created_at (ISO)
 * @param {string} theme - 'light' | 'dark'
 */
const PaymentDeadlineTimer = ({ createdAt, theme = 'light' }) => {
  const deadline = createdAt
    ? new Date(createdAt).getTime() + PAY_WINDOW_MINUTES * 60 * 1000
    : null;

  const calcLeft = () =>
    deadline ? Math.max(0, Math.floor((deadline - serverNowMs()) / 1000)) : 0;

  const [left, setLeft] = useState(calcLeft);

  useEffect(() => {
    if (!deadline) return undefined;
    setLeft(calcLeft());
    const id = setInterval(() => setLeft(calcLeft()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deadline]);

  if (!deadline) return null;

  const expired = left <= 0;
  const urgent = left <= 60;
  const mm = Math.floor(left / 60);
  const ss = String(left % 60).padStart(2, '0');

  const color = expired ? '#c62828' : urgent ? '#e65100' : theme === 'dark' ? '#ffd54f' : '#8a6d00';
  const bg = expired
    ? theme === 'dark' ? 'rgba(198,40,40,0.18)' : '#ffebee'
    : urgent
      ? theme === 'dark' ? 'rgba(230,81,0,0.18)' : '#fff3e0'
      : theme === 'dark' ? 'rgba(255,213,79,0.12)' : '#fff8e1';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        background: bg,
        color,
        borderRadius: 10,
        padding: '10px 12px',
        fontSize: 14,
        fontWeight: 600,
        margin: '12px 0',
        textAlign: 'center',
        lineHeight: 1.3,
      }}
    >
      {expired ? (
        <span>⏱ Время брони истекло — оформите заказ заново</span>
      ) : (
        <span>⏱ Оплатите в течение {mm}:{ss}, иначе бронь отменится</span>
      )}
    </div>
  );
};

export default PaymentDeadlineTimer;
